import * as React from "react";
const SvgWindowsLogo = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 88 88", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 12.4l35.7-4.9V42L0 42.2zm35.7 33.5v34.5L0 75.4V45.8zM40 7L87.3 0v41.5L40 42zm47.3 39.4v41.3L40 80.9V46.2z", fill: "#00adef" }));
export default SvgWindowsLogo;
